// 施工中心信息模块

export default {
  state: {
    id: '',
    name: '',
    code: '',
    tenantId: '',
    province: '',
    provinceCode: '',
    city: '',
    cityCode: '',
    district: '',
    districtCode: '',
    address: '',
    contacts: '',
    contactsPhone: ''
  },
  mutations: {
    updateWorkCenterInfo (state, payload) {
      payload = payload || {}

      for (const key in state) {
        if (Object.hasOwnProperty.call(state, key)) {
          state[key] = payload[key] || ''
        }
      }
    }
  }
}